// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","header_text":"Header_header_text__FA-r6","header_paragraph":"Header_header_paragraph__E1fQ-"};